import { render, staticRenderFns } from "./ai_widget_segment.vue?vue&type=template&id=560cbb3c"
import script from "./ai_widget_segment.vue?vue&type=script&lang=js"
export * from "./ai_widget_segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports